import styled from "styled-components";
import { TAG_STATUS } from "../../../../utils/epgUtil";

export const MetaDataWrapper = styled.div`
  padding: 2.5rem 0rem;
  color: #f1f1f1;
`;

export const ChannelImageWrapper = styled.div``;

// BackIconWrapper - START

export const BackIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const BackIcon = styled.div`
  box-sizing: border-box;
  border: 2px solid rgba(209, 211, 212, 0.24);
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.3125rem 0rem 0rem 0.6125rem;
  &.arabic {
    transform: rotateY(180deg);
  }
`;
export const BackText = styled.div`
  ${props => `${props.direction === "rtl" ? "margin-right" : "margin-left"}: 1rem`};
  color: #ffffff;
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.25rem;
`;

// BackIconWrapper - END

// TimeStatusWrapper - START

export const TimeStatusWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.5rem;
`;
export const StatusWrapper = styled.div`
  color: ${props => (props.status !== TAG_STATUS.live ? "#000000" : "#ffffff")};
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: ${props => (props.direction === "rtl" ? "2rem" : "1.5rem")};
  border-radius: ${props => props.theme.borderRadius.xsmall};
  background: ${props => (props.status !== TAG_STATUS.live ? "#ffffff" : "#ff3838")};
  padding: 0.2rem;
`;
export const TimeWrapper = styled.div`
  ${props => `${props.direction === "rtl" ? "margin-right" : "margin-left"}: 1.3rem`};
  color: #ffffff;
  font-size: 1.3rem;
  font-weight: bold;
  letter-spacing: 1.5px;
  line-height: 1.5rem;
`;

// TimeStatusWrapper - END

export const TagsWrapper = styled.div`
  margin-top: 0.82rem;
`;
export const Tags = styled.span`
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.25rem;
  &:after {
    background-color: #ffffff;
    content: "";
    display: inline-block;
    height: 0.4rem;
    width: 0.4rem;
    border-radius: 100%;
    margin-left: 1rem;
    margin-right: 1rem;
    margin-bottom: 0.1875rem;
  }
  &:last-child::after {
    content: none;
  }
`;

export const DescriptionWrapper = styled.div`
  color: #f1f1f1;
  font-size: 1.4rem;
  letter-spacing: 0;
  margin-top: 0.82rem;
  line-height: 2rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

// export const ImageStyled = styled.image``;

export const ImageStyled = styled.div`
  padding: 0.75rem 0;
  height: 5rem;
  width: 8rem;
`;

export const TitleStyled = styled.h2`
  color: #ffffff;
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 4rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;
